import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { deltaE, hexToHSL, hexToRgb, hexToRgbA, HSLToRGB, relativeLuminanceW3C, rgbToHex } from './color-utils';
import { argbFromRgba, rgbaFromArgb } from './hct-color-utils/color-utils';
import { Contrast } from './hct-color-utils/contrast';
import { Hct } from './hct-color-utils/hct';
var lowLuminanceContrastRatios = [1.12, 1.33, 2.03, 2.73, 3.33, 4.27, 5.2, 6.62, 12.46, 14.25];
var highLuminanceContrastRatios = [1.08, 1.24, 1.55, 1.99, 2.45, 3.34, 4.64, 6.1, 10.19, 12.6];
export var getClosestColorIndex = function getClosestColorIndex(themeRamp, brandColor) {
  // Iterate over themeRamp and find whichever color is closest to brandColor
  var closestColorIndex = 0;
  var closestColorDistance = null;
  themeRamp.forEach(function (value, index) {
    var distance = deltaE(hexToRgb(value), hexToRgb(brandColor));
    if (closestColorDistance === null || distance < closestColorDistance) {
      closestColorIndex = index;
      closestColorDistance = distance;
    }
  });
  return closestColorIndex;
};
export var generateColors = function generateColors(brandColor) {
  // Determine luminance
  var HSLBrandColorHue = hexToHSL(brandColor)[0];
  var baseRgb = HSLToRGB(HSLBrandColorHue, 100, 60);
  var isLowLuminance = relativeLuminanceW3C(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
  // Choose right palette
  var themeRatios = isLowLuminance ? lowLuminanceContrastRatios : highLuminanceContrastRatios;
  var brandRgba = hexToRgbA(brandColor);
  var hctColor = Hct.fromInt(argbFromRgba({
    r: brandRgba[0],
    g: brandRgba[1],
    b: brandRgba[2],
    a: brandRgba[3]
  }));
  var themeRamp = themeRatios.map(function (contrast) {
    var rgbaColor = rgbaFromArgb(Hct.from(hctColor.hue, hctColor.chroma, Contrast.darker(100, contrast) + 0.25 // Material's utils provide an offset
    ).toInt());
    return rgbToHex(rgbaColor.r, rgbaColor.g, rgbaColor.b);
  });
  var closestColorIndex = getClosestColorIndex(themeRamp, brandColor);

  // Replace closet color with brandColor
  var updatedThemeRamp = _toConsumableArray(themeRamp);
  updatedThemeRamp[closestColorIndex] = brandColor;
  return updatedThemeRamp;
};
export var generateColorRamps = function generateColorRamps(primaryColor) {
  var colors = generateColors(primaryColor);
  return {
    color100: colors[0],
    color200: colors[1],
    color300: colors[2],
    color400: colors[3],
    color500: colors[4],
    color600: colors[5],
    color700: colors[6],
    color800: colors[7],
    color900: colors[8],
    color1000: colors[9]
  };
};